import { getTenantId, setLocalTenantId } from "@/lib/storeManager";
import { createContext, ReactNode, useState } from "react";

interface TenantContextType {
  tenantId: string | null;
  setTenantId: (id: string) => void;
  clearTenantId: () => void;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

interface TenantProviderProps {
  children: ReactNode;
}

// export const TenantProvider: React.FC<TenantProviderProps> = ({ children }) => {
//   const [tenantId, setTenantIdState] = useState<string | null>(() => {
//     // Initialize from localStorage or URL path
//     const storedTenantId = getTenantId();
//     if (storedTenantId) {
//       return storedTenantId;
//     }

//     // Extract from URL path
//     const pathParts = window.location.pathname.split("/").filter(Boolean);
//     return pathParts.length > 0 ? pathParts[0] : null;
//   });

//   const setTenantIdHandler = (id: string) => {
//     setLocalTenantId(id);
//     setTenantIdState(id);
//   };

//   const clearTenantId = () => {
//     localStorage.removeItem("tenantId");
//     setTenantIdState(null);
//   };

//   // Update tenant ID when URL changes
//   useEffect(() => {
//     const handleUrlChange = () => {
//       const pathParts = window.location.pathname.split("/").filter(Boolean);
//       const urlTenantId = pathParts.length > 0 ? pathParts[0] : null;

//       if (
//         urlTenantId &&
//         urlTenantId !== "undefined" &&
//         urlTenantId !== "null"
//       ) {
//         setTenantIdHandler(urlTenantId);
//       }
//     };

//     // Listen for popstate events (browser back/forward)
//     window.addEventListener("popstate", handleUrlChange);

//     // Initial check
//     handleUrlChange();

//     return () => {
//       window.removeEventListener("popstate", handleUrlChange);
//     };
//   }, []);

//   return (
//     <TenantContext.Provider
//       value={{
//         tenantId,
//         setTenantId: setTenantIdHandler,
//         clearTenantId,
//       }}
//     >
//       {children}
//     </TenantContext.Provider>
//   );
// };

export const TenantProvider: React.FC<TenantProviderProps> = ({ children }) => {
  // Initialize from localStorage or VITE_X_TENANTID env (tenant ID no longer in URL)
  const [tenantId, setTenantIdState] = useState<string | null>(() =>
    getTenantId()
  );

  const setTenantIdHandler = (id: string) => {
    setLocalTenantId(id);
    setTenantIdState(id);
  };

  const clearTenantId = () => {
    localStorage.removeItem("tenantId");
    setTenantIdState(null);
  };

  return (
    <TenantContext.Provider
      value={{
        tenantId,
        setTenantId: setTenantIdHandler,
        clearTenantId,
      }}
    >
      {children}
    </TenantContext.Provider>
  );
};

// Export the context for use in other files
export { TenantContext };
